import RootStore from './RootStore';
import CmsDataStore from './CmsDataStore';
import { parseParams } from '../util/ParamsUtil';

export interface GaData {
  event?: string;
  eventCategory?: string;
  eventAction?: string;
  eventLabel?: string;
}

export interface GaDataParams {
  [key: string]: string;
}

export class GaDataStore {
  private cmsDataStore: CmsDataStore;

  constructor(rootStore: RootStore) {
    this.cmsDataStore = rootStore.cmsDataStore;
  }

  private createEventLabel(label: string, params: GaDataParams): string {
    const data: { [param: string]: any } = {};
    for (const [param, key] of Object.entries(params)) {
      data[param] = this.cmsDataStore.getData(key);
    }
    return parseParams(label, data);
  }

  private resolveGaData(data: GaData, params?: GaDataParams) {
    const { eventLabel } = data;
    const label = eventLabel && params ? this.createEventLabel(eventLabel, params) : eventLabel;
    return { ...data, eventLabel: label };
  }

  public push(data: GaData, params?: GaDataParams) {
    if (window.dataLayer) {
      const resolved = this.resolveGaData(data, params);
      window.dataLayer.push(resolved);
    }
  }

  public static pushWithoutCmsData(data: GaData, params?: GaDataParams) {
    if (window.dataLayer) {
      const { eventLabel, eventAction } = data;
      const label = eventLabel && params ? parseParams(eventLabel, params) : eventLabel;
      const action = eventAction && params ? parseParams(eventAction, params) : eventAction;
      window.dataLayer.push({ ...data, eventAction: action, eventLabel: label });
    }
  }
}

export default GaDataStore;
